import styled, { css } from "styled-components";

export const ImageGrid = styled.div`
  /* Prevent vertical gaps */
  line-height: 0;

  -webkit-column-count: 5;
  -webkit-column-gap: 0px;
  -moz-column-count: 5;
  -moz-column-gap: 0px;
  column-count: 5;
  column-gap: 0px;

  @media (max-width: 1200px) {
    column-count: 4;
  }
  @media (max-width: 1000px) {
    column-count: 3;
  }
  @media (max-width: 800px) {
    column-count: 2;
  }
  @media (max-width: 400px) {
    column-count: 1;
  }

  ${(props) =>
    props.displayMode === "fullscreen" &&
    css`
      column-count: 1 !important;
    `};

  ${(props) =>
    props.columns &&
    props.columns !== "fluid" &&
    css`
      column-count: ${props.columns} !important;
    `};
`;
